import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    Currency, LaneFeesAllowed,
    FeeChargeability, ProductType,
} from 'app/enums/label.enums'

import {
    LaneFees,
} from '../../CQuotes.types'

const getColumns = (
    l: (l:string) => string, currency: Currency,
): RichTableColumns<keyof LaneFees>[] => {
    return [
        {
            id: 'feeName',
            headerProps: {
                children: l('Fee.feeName'),
                sorting: false,
            },
            mapCellProps: 'feeName',
            componentName: 'EnumValue',
            allowedValuesEnum: LaneFeesAllowed,
        },
        {
            id: 'feeChargeability',
            headerProps: {
                children: l('Fee.feeChargeability'),
                sorting: false,
            },
            mapCellProps: 'feeChargeability',
            componentName: 'EnumValue',
            allowedValuesEnum: FeeChargeability,
        },
        {
            id: 'productType',
            headerProps: {
                children: l('Fee.productType'),
                sorting: false,
            },
            mapCellProps: 'productType',
            componentName: 'EnumValue',
            allowedValuesEnum: ProductType,
        },
        {
            id: 'description',
            headerProps: {
                children: l('Fee.feeDescription'),
                sorting: false,
            },
            mapCellProps: 'description',
        },
        {
            id: 'feeValue',
            headerProps: {
                children: l(`Fee.${currency}`),
                sorting: false,
            },
            mapCellProps: 'feeValue',
        },
    ]
}

export default getColumns
